module.exports = __webpack_public_path__ + "img/IJuggernaut64_ua.23714681.webp";